export default __webpack_public_path__ + "static/media/CivilEng_Icon-06.68e08430.png";